import { atom } from "jotai";

interface ClientData {
  clientId: number;
  clientKey: string;
}

export const ClientStateAtom = atom<ClientData | undefined>(undefined);
